// extracted by mini-css-extract-plugin
export default {"wrapper":"accordion_wrapper__DJaP6","header":"accordion_header__karDn","headerBorder":"accordion_headerBorder__JKoDy"};